import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/auth'
import VueGtag from 'vue-gtag'

Vue.use(Router)

// export default new Router({
const router = new Router({
  // mode: 'hash',
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/pages',
      component: () => import('@/views/pages/Index'),
      // children: [
      //   {
      //     name: 'Login',
      //     path: 'login',
      //     component: () => import('@/views/pages/Login'),
      //   },
      // ],
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Dashboard
        // {
        //   name: 'HOME',
        //   path: '',
        //   component: () => import('@/views/dashboard/Dashboard'),
        //   meta: { requiresAuth: true },
        // },
        // Pages
        // {
        //   name: 'User Profile',
        //   path: 'pages/user',
        //   component: () => import('@/views/dashboard/pages/UserProfile'),
        // },
        // Maps
        // {
        //   name: 'Google Maps',
        //   path: 'maps/google-maps',
        //   component: () => import('@/views/dashboard/maps/GoogleMaps'),
        // },
        // {
        //   name: 'Full Screen Map',
        //   path: 'maps/full-screen-map',
        //   component: () => import('@/views/dashboard/maps/FullScreenMap'),
        // },
        // Root level
        // {
        //   name: 'HOME',
        //   path: 'HOME',
        //   component: () => import('@/views/admin/Home'),
        //   meta: { requiresAuth: true },
        // },
        // {
        //   name: 'Login',
        //   path: 'login',
        //   component: () => import('@/views/pages/Login'),
        // },
        {
          name: '',
          path: '',
          component: () => import('@/views/pages/Error'),
          meta: { requiresAuth: false },
        },
        {
          name: 'pages',
          path: ':partnerUrl/:siteUrl',
          component: () => import('@/views/momento/Pages'),
          meta: { requiresAuth: false },
        },
        {
          name: 'review',
          path: ':partnerUrl/:siteUrl/review',
          component: () => import('@/views/momento/Review'),
          meta: { requiresAuth: false },
        },
        {
          name: 'letter',
          path: ':partnerUrl/:siteUrl/letter',
          component: () => import('@/views/momento/Letter'),
          meta: { requiresAuth: false },
        },
        {
          name: 'link',
          path: ':partnerUrl/:siteUrl/link',
          component: () => import('@/views/momento/Link'),
          meta: { requiresAuth: false },
        },
      ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})
console.log('G-5348M5S6XG')
Vue.use(VueGtag, {
  config: { id: 'G-5348M5S6XG' },
}, router)

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) {
    // このルートはログインされているかどうか認証が必要です。
    // もしされていないならば、ログインページにリダイレクトします。
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        next()
      } else {
        next({
          path: '/',
          query: { redirect: to.fullPath },
        })
      }
    })
  } else {
    next() // next() を常に呼び出すようにしてください!
  }
})

export default router
